import { ReactNode } from "react";
import { ButtonIcon, ButtonIconProps } from "..";
import useTooltip from "../../hooks/useTooltip";
//tool-tip 있는 버튼
//hover시 tool-tip 뜨도록
type ButtonWithTooltipProps = {
  title?: string | ReactNode;
  tooltipClassName?: string;
} & ButtonIconProps;

const ButtonWithTooltip = (props: ButtonWithTooltipProps) => {
  const { title, tooltipClassName, ...buttonProps } = props;
  const { showTooltip, handleHover } = useTooltip();

  return (
    <div
      className="button-with-tooltip"
      onMouseOver={handleHover(true)}
      onMouseLeave={handleHover(false)}
    >
      <ButtonIcon {...buttonProps} />
      <div className={`${tooltipClassName || "tool-tip"} ${showTooltip ? "hover" : ""}`}>
        {title}
      </div>
    </div>
  );
};

export default ButtonWithTooltip;
